import React from 'react';

interface NodeIconProps {
  objectType: string;
}

export const NodeIcon: React.FC<NodeIconProps> = ({ objectType }) => {
  return (
    <span
      className={`type ${objectType}`}
      style={{
        display: 'inline-block',
        width: '14px',
        height: '14px',
        textAlign: 'center',
        marginRight: '4px',
      }}
    >
      ●
    </span>
  );
};
